{
	"title": "Asigurarea responsabilității prin implementarea unei bănci de carbon",
	"description": "Heidelberg Materials a luat măsuri riguroase pentru a garanta credibilitatea reducerilor de carbon generate de fabrica noastră de ciment cu CCS. Pentru a preveni orice posibilitate de dublă contabilizare, am implementat o bancă de carbon virtuală securizată pe un registru distribuit public.",
	"traceabilityTitle": "Trasabilitatea reducerilor de carbon"
}
